import { useEffect } from 'react';
import { useLocation } from 'wouter';
import {
  applyThemeForLocation,
  currentStoreSlug,
  STORE_THEME_EVENT,
} from '@/shared/utils/store-theme';

/**
 * Mantém as cores do app iguais às escolhidas pela loja aberta (PRAT-154):
 * repinta a cada troca de tela e quando a API devolve um tema novo.
 */
export function StoreThemeSync() {
  const [location] = useLocation();

  useEffect(() => {
    applyThemeForLocation(window.location.pathname);
  }, [location]);

  useEffect(() => {
    const onTheme = (event: Event) => {
      const { slug } = (event as CustomEvent<{ slug: string }>).detail ?? {};
      if (slug && slug === currentStoreSlug(window.location.pathname)) {
        applyThemeForLocation(window.location.pathname);
      }
    };
    window.addEventListener(STORE_THEME_EVENT, onTheme);
    return () => window.removeEventListener(STORE_THEME_EVENT, onTheme);
  }, []);

  return null;
}
